import { makeStyles } from '@rbx/ui';

const useObjectContainerStyles = makeStyles()(() => ({
  descriptionContainer: {
    marginTop: '24px',
  },

  attributesHeader: {
    marginTop: '24px',
    marginBottom: '24px',
  },
}));

export default useObjectContainerStyles;
